<template>
  <div>
    <v-container fluid>
      <v-card>
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Alterar senha</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            class="primary lighten-4 mr-2"
            @click="$router.go(-1)"
            :disabled="loading"
            >Cancelar</v-btn
          >
          <v-btn
            class="primary lighten-4"
            @click="salvar"
            :loading="loading"
            :disabled="!form_valid"
            >Salvar</v-btn
          >
        </v-app-bar>

        <v-form ref="form" v-model="form_valid" lazy-validation>
          <v-container grid-list-lg fluid>
            <v-layout row>
              <v-flex xs12 sm8 lg4 offset-lg4 offset-sm2>
                <!-- <v-text-field
                  v-model="user.currentPassword"
                  autofocus
                  ref="senha_atual"
                  color="primary"
                  label="Senha atual"
                  type="password"
                  :rules="rules.currentPassword"
                  @keyup.enter="$refs.senha.focus()"
                  autocomplete="off"
                  role="presentation"
                ></v-text-field> -->
                <v-text-field
                  v-model="user.newPassword"
                  ref="senha"
                  color="primary"
                  label="Nova senha"
                  type="password"
                  :rules="rules.newPassword"
                  @keyup.enter="$refs.confirmar_senha.focus()"
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
                <v-text-field
                  v-model="user.confirmPassword"
                  ref="confirmar_senha"
                  color="primary"
                  type="password"
                  label="Confirmar nova senha"
                  :rules="rules.confirmPassword"
                  @keyup.enter="salvar"
                  autocomplete="off"
                  role="presentation"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import ServicesUsers from "@/services/users.js";

export default {
  data() {
    return {
      loading: false,
      form_valid: true,
      user: {
        newPassword: "",
        currentPassword: "",
        confirmPassword: "",
      },

      errors: {},

      rules: {
        newPassword: [(v) => !!v || "Campo obrigatório"],
        currentPassword: [(v) => !!v || "Campo obrigatório"],
        confirmPassword: [
          (v) => !!v || "Campo obrigatório",
          (v) => v == this.user.newPassword || "As senhas devem ser iguais",
        ],
      },
    };
  },

  mounted() {
    //
  },

  methods: {
    async salvar() {
      if (this.$refs.form.validate()) {
        try {
          this.loading = true;
          await ServicesUsers.changePassword(this.user, this.$auth.user.id);
          this.$eventbus.notificar("Senha alterada com sucesso");
          this.$router.go(-1);
        } catch (error) {
          this.$eventbus.erro(
            error.response?.data?.message ||
              error.response?.data?.msg ||
              "Erro ao salvar os dados",
            error
          );
        } finally {
          this.loading = false;
        }
      }
    },
  },

  watch: {
    user: {
      handler: function(val, oldVal) {
        this.$refs.form.resetValidation();
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
